/**
 * @file Account related mutations.
 */

import gql from 'graphql-tag';

import {
  IdentityDetails,
  IdentityJoinedAlbums,
  IdentityMatchingWarningFields,
} from '../fragments/identity';
import { PhotoUrlTypeFields } from '../fragments/album';

export const updateSelfie = gql`
  mutation updateSelfie($input: UpdateSelfieInput!) {
    updateSelfie(input: $input) {
      identity {
        ...IdentityDetails
        ...IdentityJoinedAlbums
      }
    }
  }
  ${IdentityDetails}
  ${IdentityJoinedAlbums}
`;

export const identitySelfieUpdate = gql`
  mutation identitySelfieUpdate($input: IdentitySelfieUpdateInput!) {
    identitySelfieUpdate(input: $input) {
      identity_selfie {
        id
        face {
          id
          facebox
        }
        photo {
          id
          thumbnail_urls {
            ...PhotoUrlTypeFields
          }
        }
        identity {
          id
          reference_images: selfies(matching_enabled: true) {
            total
          }
        }
      }
    }
  }
  ${PhotoUrlTypeFields}
`;

export const identityMatchingWarningCreate = gql`
  mutation identityMatchingWarningCreate(
    $input: IdentityMatchingWarningCreateInput!
  ) {
    identityMatchingWarningCreate(input: $input) {
      identity_matching_warning {
        ...IdentityMatchingWarningFields
      }
    }
  }
  ${IdentityMatchingWarningFields}
`;

export const identityMatchingWarningUpdate = gql`
  mutation identityMatchingWarningUpdate(
    $input: IdentityMatchingWarningUpdateInput!
  ) {
    identityMatchingWarningUpdate(input: $input) {
      identity_matching_warning {
        ...IdentityMatchingWarningFields
      }
    }
  }
  ${IdentityMatchingWarningFields}
`;
